import { Injectable, ElementRef, NgZone } from '@angular/core';
import { FormGroup } from '@angular/forms';

declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {

  constructor(private ngZone: NgZone) {}

  initAutocomplete(
    inputElement: ElementRef,
    formGroup: FormGroup,
    options?: {
      parentPath?: string;
      fieldMapping?: {
        address1?: string;
        city?: string;
        state?: string;
        zip?: string;
      };
      includeZipSuffix?: boolean;
      sanitizeZip?: boolean;
    }
  ): void {

    const config = {
      parentPath: options?.parentPath ?? null,
      includeZipSuffix: options?.includeZipSuffix ?? true,
      sanitizeZip: options?.sanitizeZip ?? true,
      fieldMapping: {
        address1: options?.fieldMapping?.address1 ?? 'address1',
        city: options?.fieldMapping?.city ?? 'city',
        state: options?.fieldMapping?.state ?? 'state',
        zip: options?.fieldMapping?.zip ?? 'zip'
      }
    };

    const autocomplete = new google.maps.places.Autocomplete(
      inputElement.nativeElement,
      {
        types: ['address'],
        componentRestrictions: { country: 'us' },
        fields: ['address_components']
      }
    );

    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {

        const place = autocomplete.getPlace();
        if (!place?.address_components) return;

        const get = (types: string[]) =>
          place.address_components.find((c: any) =>
            types.some(t => c.types.includes(t))
          );

        const street =
          `${get(['street_number'])?.long_name || ''} ${get(['route'])?.long_name || ''}`.trim();

        const city =
          get(['locality'])?.long_name ||
          get(['sublocality'])?.long_name ||
          get(['administrative_area_level_2'])?.long_name ||
          '';

        const state =
          get(['administrative_area_level_1'])?.short_name || '';

        const zip =
          get(['postal_code'])?.long_name || '';

        const zipSuffix =
          get(['postal_code_suffix'])?.long_name || '';

        let fullZip = config.includeZipSuffix && zipSuffix
          ? `${zip}-${zipSuffix}`
          : zip;

        if (config.sanitizeZip) {
          fullZip = fullZip.replace(/\D/g, '');
        }

        const targetGroup = config.parentPath
          ? formGroup.get(config.parentPath)
          : formGroup;

        if (!targetGroup) return;

        targetGroup.patchValue({
          [config.fieldMapping.address1]: street,
          [config.fieldMapping.city]: city,
          [config.fieldMapping.state]: state,
          [config.fieldMapping.zip]: fullZip
        });

        inputElement.nativeElement.value = street;

      });
    });
  }
}